__webpack_require__.p = "https://live.asktek.net/iog.padma.webapp/";